<script>
import {axiosApiInstance} from "@/axiosInterceptor";
import {loadScript} from '/src/assets/utils'
import TopNavbar from "@/layout/dashboard/TopNavbar.vue";

export default {
  data() {
    return {
      user: null,
      flash: null,
      loading: true
    }
  },
  mounted() {
    this.getMeltingSpotToken()
  },
  methods: {
    clearFlash() {
      this.flash = null
    },
    updateFlash(message, type) {
      this.flash = {message: message, type: type}
      setTimeout(() => {
        this.clearFlash()
      }, 3000)
    },
    getMeltingSpotToken() {
      axiosApiInstance.get(process.env.VUE_APP_API_URL + '/meltingspot/create-token').then(response => {
        this.token = response.data

        return loadScript('https://cdn.jsdelivr.net/npm/@meltingspot/meltingspot-js')
            .then(() => {
              window.MeltingSpot.injectSpotInto('meltingspot-frame', {
                spotId: process.env.VUE_APP_MS_ID,
                themeMode: 'light',
                authToken: this.token
              })
              this.loading = false
            })
            .catch((error) => {
              this.updateFlash('Une erreur est survenue.', 'danger')
              console.error('Erreur lors de l’intégration de MeltingSpot :', error)
              this.loading = false
            })

      })
          .catch(e => console.error(e))
    }
  },
  components: {
    TopNavbar,
  }
}

</script>

<template>
  <div class="wrapper">
    <div class="position-fixed top-0 start-50 translate-middle-x p-3" style="z-index: 11;padding-top:33px !important;">
      <div :class="'toast bg-' + flash.type + ' ' + (flash?'show':'hide')" v-if="flash">
        <div class="d-flex">
          <div class="toast-body">
            {{ flash.message }}
          </div>
          <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                  aria-label="Fermer" @click="clearFlash"></button>
        </div>
      </div>
    </div>

    <side-bar>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <div class="content">
        <h1>Académie</h1>
        <p class="loader" v-if="loading">Chargement du widget...</p>
        <div class="content">
          <div id="meltingspot-frame"></div>
        </div>
      </div>
    </div>
  </div>

</template>

<style>
#meltingspot-frame {
  width: 100%;
}

#meltingspot-frame iframe {
  height: 80vh;
}
</style>